import store from './store'

const normalizeCompatType = (type) => {
    if(!type){ return '' }
    var normalized = type.toString().toLowerCase()
    if(normalized == 'gpu'){ return 'graphics' }
    if(normalized == 'processor'){ return 'cpu' }
    if(normalized == 'power supply'){ return 'psu' }
    return normalized
}

const getCompatTypeTable = (table, type) => {
    var normalized = normalizeCompatType(type)
    if(!table || !normalized){ return null }
    if(table[normalized]){ return table[normalized] }
    if(normalized == 'graphics' && table.gpu){ return table.gpu }
    if(normalized == 'gpu' && table.graphics){ return table.graphics }
    return null
}

export const functions = {
    test(){
        // store.dispatch('isCompatible', {item: item, withType: withType, option: option})
    },
    createCompatTable       ({build, checkItem}){
        // var startTime = performance.now()
        var testCases = {
            cpu: {
                motherboard: [
                    'socket',
                    'processor_generation'
                ],
                ram: [
                    'ram_type',
                    'ram_speed',
                    'max_memory',
                ],
                cooling: [
                    'socket',
                ]
            },
            motherboard: {
                cpu: [
                    'socket',
                    'ram_type',
                    'ram_speed',
                    'processor_generation',
                ],
                ram: [
                    'ram_type',
                    'ram_speed',
                    'number_of_items',
                    'max_memory'
                ],
                psu: [
                    'form_factor'
                ],
                case: [
                    'form_factor'
                ],
                graphics: [
                    'pci_e_x16'
                ],
                storage: [
                    'interface',
                    'sata_slots',
                    'm.2_slots'
                ],
            },
            ram: {
                cpu: [
                    'ram_type',
                    'ram_speed',
                    'max_memory'
                ],
                motherboard: [
                    'ram_type',
                    'max_memory',
                    'ram_speed',
                    'ram_slots'
                ]
            },
            storage: {
                motherboard: [
                    'interface',
                    'sata',
                    'sata_slots',
                    'm.2_slots'
                ],
            },
            graphics: {
                motherboard: [
                    'pci_e_x16'
                ],
            },
            psu: {
                general: [
                    'power'
                ],
                motherboard: [
                    'form_factor'
                ],
                case: [
                    'form_factor'
                ],
            },
            case: {
                motherboard: [
                    'form_factor'
                ],
                psu: [
                    'form_factor'
                ],
                cooling: [
                    'form_factor',
                ]
            }
        }
        var buildList = Object.keys(build)
        var oneItem
        var otherItem
        var oneItemType
        var otherItemType
        var option = ''
        // var compatTable = {}
        // If Item exists in build
        store.dispatch('resetWarnings')
        if(checkItem){
            // Build power is not a physical menu slot, so it is absent from
            // `buildList`. Evaluate it explicitly for PSU candidates; otherwise
            // Compatible Only has no power result even though the list tile's
            // live check correctly marks an undersized PSU as incompatible.
            if(normalizeCompatType(checkItem.type) == 'psu'){
                testCases.psu.general.forEach((generalOption) => {
                    store.dispatch('isCompatible', {
                        item: checkItem,
                        withType: 'general',
                        option: generalOption,
                        forLib: true
                    })
                })
            }
            buildList.forEach(type => {
                if(build[type] && build[type].item.contents){
                    otherItem = build[type]
                    otherItemType = normalizeCompatType(otherItem.type)
                    for (var i = 0; i< buildList.filter((item) => item !== type).length; i++){
                        oneItem = {
                            type: checkItem.type,
                            item: {
                                contents: checkItem
                            }
                        }
                        // IF NOT ARRAY
                        if(oneItem.item.contents && oneItem.item.contents.type){
                            oneItemType = normalizeCompatType(oneItem.type)
                            if(oneItem.type == 'gpu'){
                                oneItemType = 'graphics'
                             }
                            if(    testCases[oneItemType] 
                                && testCases[oneItemType][otherItemType] 
                                && testCases[oneItemType][otherItemType].length >0){
                                for(var opt = 0; opt < testCases[oneItemType][otherItemType].length; opt++){
                                    option  = testCases[oneItemType][otherItemType][opt]
                                    store.dispatch('isCompatible', {item: oneItem.item.contents, withType: otherItemType, option: option, forLib: true})
                                }
                            }
                        }
                        // IF ARRAY
                        if(oneItem.item.contents && typeof(oneItem.item.contents) == 'object' && oneItem.item.contents.length >0){
                            oneItemType = normalizeCompatType(oneItem.item.contents[0].type)
                            if(oneItem.type == 'gpu'){
                               oneItemType = 'graphics'
                            }
                            for(var m = 0; m < oneItem.item.contents.length; m++){
                                if(    testCases[oneItemType] 
                                    && testCases[oneItemType][otherItemType] 
                                    && testCases[oneItemType][otherItemType]){
                                    for(var opti = 0; opti < testCases[oneItemType][otherItemType].length; opti++){
                                        option  = testCases[oneItemType][otherItemType][opti]
                                        store.dispatch('isCompatible', {item: oneItem.item.contents[m], withType: otherItemType, option: option, forLib: true})
                                    }
                                }
                            }
                        }
                    }
                }
            });
            // var endTime = performance.now()
            return store.getters.getCompatLib
        }
        else if(build){
            buildList.forEach(type => {
                if(build[type] && build[type].item.contents){
                    otherItem = build[type]
                    otherItemType = normalizeCompatType(otherItem.type)
                    var comparisonList = buildList.filter((item) => item !== type)
                    for (var i = 0; i< comparisonList.length; i++){
                        oneItem = build[comparisonList[i]]
                        // IF NOT ARRAY
                        if(oneItem.item.contents && oneItem.item.contents.type){
                            oneItemType = normalizeCompatType(oneItem.type)
                            if(    testCases[oneItemType] 
                                && testCases[oneItemType][otherItemType] 
                                && testCases[oneItemType][otherItemType].length >0){
                                for(var opt = 0; opt < testCases[oneItemType][otherItemType].length; opt++){
                                    option  = testCases[oneItemType][otherItemType][opt]
                                    store.dispatch('isCompatible', {item: oneItem.item.contents, withType: otherItemType, option: option, forState: true})
                                }
                            }
                        }
                        // IF ARRAY
                        if(oneItem.item.contents && typeof(oneItem.item.contents) == 'object' && oneItem.item.contents.length >0){
                            oneItemType = normalizeCompatType(oneItem.item.contents[0].type)
                            if(oneItem.type == 'gpu'){
                               oneItemType = 'graphics'
                           }
                            for(var m = 0; m < oneItem.item.contents.length; m++){
                                if(    testCases[oneItemType] 
                                    && testCases[oneItemType][otherItemType] 
                                    && testCases[oneItemType][otherItemType]){
                                    for(var opty = 0; opty < testCases[oneItemType][otherItemType].length; opty++){
                                        option  = testCases[oneItemType][otherItemType][opty]
                                        store.dispatch('isCompatible', {item: oneItem.item.contents[m], withType: otherItemType, option: option, forState: true})
                                    }
                                }
                            }
                        }
                    }
                }
            });
            console.log('compatibility table updated ', store.getters.getStateCompatTable)
            if(store.getters.getWarnings && store.getters.getWarnings.length > 0){
                store.dispatch('updateBuildStatus', 'warning')
            }
            else {
                store.dispatch('updateBuildStatus', 'ok')
            }
            // var endTime = performance.now()
            // console.log('[createCompatTable] EXECUTED IN ', (endTime - startTime)/1000 + ' seconds')
            return store.getters.getStateCompatTable
        }
    },
    getBuildPerformance(build, myBuild){
        var results = {}
        if(build) {
            var totalItems = 0;
            var totalScore = 0;
            for (const field in build){
                var type = ''
                var processingItem = new Object()
                var perfIndex = 0
                // IF RANDON BUILD
                if(myBuild == false){
                    if(build[field] && typeof(build[field]) == 'object' && build[field][0]){
                        if(build[field][0]){
                            type = build[field][0].type
                            processingItem = build[field]
                        }
                    }
                    else {
                        if(build[field] && build[field].type){
                            type = build[field].type
                            processingItem = build[field]
                        }
                    }
                }
                else {
                    if(build[field] && build[field].item && build[field].item.type){
                        type = build[field].item.type
                        processingItem = build[field].item.contents
                    }
                }
                if(processingItem){
                    if(!results[type]) {
                        results[type] = 0
                    }
                    // IF GPU RAM STORAGE
                    if(typeof(processingItem) == 'object' && processingItem.length >0){
                        perfIndex = 0;
                        var pciStorage = 0
                        var sataHddStorage = 0
                        var sataSsdStorage = 0
                        var storagePerf = 0
                        var storagePerf_temp = 0
                        var graphics = 0
                        for (var i = 0; i< processingItem.length; i++){
                            if(type == 'ram'){
                                var ramPerf = (parseFloat(processingItem[i].compat.capacity)*0.5)
                                totalScore += ramPerf
                                results[type] = results[type] + ramPerf
                            }
                            if(type == 'graphics' || type == 'gpu'){
                                graphics++
                                perfIndex = 0;
                                var core_freqency           = parseFloat(processingItem[i].specs[ 'GPU_clock_speed' ]);
                                var graphics_ram_capacity   = parseFloat(processingItem[i].specs[ 'graphics_ram_capacity' ]);
                                // Derive memory bandwidth from memory clock x bus width (consistently
                                // present) instead of the unreliable memory_transfer_speed spec, so two
                                // listings of the same GPU always score identically.
                                var memBandwidth = ((parseFloat(processingItem[i].specs[ 'memory_clock_speed' ]) * parseFloat(processingItem[i].specs[ 'memory_bus_width' ])) / 8000) || 0
                                perfIndex = (
                                    memBandwidth * (core_freqency * graphics_ram_capacity / 1000)
                                ) * 0.21
                                if(isNaN(perfIndex)){ perfIndex = 0 }
                                processingItem[i]['performance'] =  perfIndex
                                if(graphics == 2){
                                    var gpuPerf = parseFloat(processingItem[i].performance)/2
                                    totalScore += gpuPerf
                                    results[type] = results[type] + gpuPerf
                                }
                                else if(graphics == 1){
                                    var gpuPerf1 = parseFloat(processingItem[i].performance)
                                    totalScore += gpuPerf1
                                    results[type] = results[type] + gpuPerf1
                                }
                            }
                            if(type == 'storage'){
                                if(processingItem[i].compat.compat_interface.toLowerCase().includes('sata')){
                                    var diskType = processingItem[i].specs.Disk_Type
                                    if(diskType && diskType.toLowerCase() == 'hdd'){
                                        sataHddStorage++
                                        if(sataHddStorage >1){
                                            storagePerf = parseFloat(processingItem[i].specs.Capacity)/3
                                            totalScore += storagePerf
                                            results[type] = results[type] + storagePerf
                                        }
                                        else if(sataHddStorage == 1){
                                            storagePerf = ((parseFloat(processingItem[i].compat.speed)*0.1)*parseFloat(processingItem[i].specs.Capacity)) *0.1
                                            results[type] = results[type] + storagePerf
                                            totalScore += storagePerf
                                        }
                                    }
                                    if(diskType && diskType.toLowerCase() == 'ssd'){
                                        sataSsdStorage++
                                        if(sataSsdStorage >1){
                                            storagePerf_temp = parseFloat(processingItem[i].specs.Capacity)*3
                                            results[type] = results[type] + storagePerf_temp
                                            totalScore += storagePerf_temp
                                        }
                                        else if(sataSsdStorage == 1 && pciStorage == 0){
                                            storagePerf_temp = ((parseFloat(processingItem[i].compat.speed)*0.1)*parseFloat(processingItem[i].specs.Capacity)) *0.7
                                            totalScore += storagePerf_temp
                                            results[type] = results[type] + storagePerf_temp
                                        }
                                    }
                                }
                                if(processingItem[i].compat.compat_interface.toLowerCase().includes('pci')){
                                    pciStorage++
                                    if(pciStorage >1){
                                        storagePerf_temp = parseFloat(processingItem[i].specs.Capacity)
                                        results[type] = results[type] + storagePerf_temp
                                        totalScore += storagePerf_temp
                                    }
                                    else if(pciStorage == 1){
                                        if(sataSsdStorage > 0){
                                            totalScore -= storagePerf
                                            storagePerf = 0
                                        }                                        
                                        storagePerf_temp = ((parseFloat(processingItem[i].compat.speed)*0.1)*parseFloat(processingItem[i].specs.Capacity)) *0.05
                                        totalScore += storagePerf_temp
                                        results[type] = results[type] + storagePerf_temp
                                    }
                                }
                                //  totalScore += parseFloat(processingItem[i].compat.speed)*0.01
                            }
                            totalItems = totalItems++
                        }
                    }
                    else {
                        if(type == 'cpu'){
                            perfIndex = 0;
                            var frequency   = parseFloat(processingItem.specs[ 'Core_Frequency'    ]);
                            var TurboFreq   = parseFloat(processingItem.specs[ 'Turbo_Frequency'   ]);
                            var cores       = parseInt(processingItem.specs[   'Number_of_Cores'   ]);
                            var turb        = parseFloat(processingItem.specs[ 'Turbo_Boost'       ]);
                            var hyper       = processingItem.specs[            'Hyper_Threading'   ];
                            if(frequency && frequency > 1000){
                                frequency = frequency/1000
                            }
                            if(turb == true){
                                frequency = TurboFreq
                            }
                            perfIndex = frequency*cores
                            // increase by 30% If Hyper-Threading
                            if(typeof(hyper) == 'string' && hyper !== '' && hyper !== 'No'){
                                perfIndex += perfIndex *0.3
                            }
                            if(typeof(turb) == 'string' && turb !== '' && turb !== 'No'){
                                perfIndex += perfIndex *(1/frequency)
                            }
                            // increase by % if Turbo Boost
                            processingItem['performance'] =  perfIndex
                            var cpuPerf = parseFloat(processingItem.performance)
                            totalScore += cpuPerf
                            results[type] = cpuPerf
                        }
                        totalItems = totalItems++
                    }

                }
            }
            var totScore = myBuild == false ? Math.round(totalScore) : Math.round(totalScore+(totalScore*0.15))
            return {
                'Total': totScore,
                'Details': results
            }
        }
    },
    checkPartCompat({compatTable, type, asin}){
        var table = compatTable
        if(table && type && asin){
          var typeTable = table[asin] ? getCompatTypeTable(table[asin], type) : null
          if(typeTable){
            var fields = Object.keys(typeTable)
            if(fields && fields.length >0){
              for(var i = 0; i < fields.length; i++){
                if(typeTable[fields[i]]){
                  var values = Object.keys(typeTable[fields[i]])
                  for(var j = 0; j < values.length; j++){
                    if(typeTable[fields[i]][values[j]]
                    && typeTable[fields[i]][values[j]].compatible == false){
                      return false
                    }
                  }
                }
              }
            }
          }
        }
    },
    checkCompatTable(type, option, build, item, compatTable){
        var currentItemType = normalizeCompatType(item.type)
        var currentTypeTable = getCompatTypeTable(compatTable, currentItemType)
        if(type == 'general'){
            if(
                   currentTypeTable
                && currentTypeTable[type]
                && currentTypeTable[type][option]
                && currentTypeTable[type][option].compatible == false
            ){
                return false
            }
            if(
                   currentTypeTable
                && currentTypeTable[type]
                && currentTypeTable[type][option]
                && currentTypeTable[type][option].compatible == true
            ){
                return true
            }
        }
        if(
            build
            && build[type]
            && build[type].item.contents
            && currentTypeTable
            && currentTypeTable[type]
            && currentTypeTable[type][option]
            && currentTypeTable[type][option].compatible == false
        ){
            return false
        }
        else if (
            build
            && build[type]
            && build[type].item.contents
            && currentTypeTable
            && currentTypeTable[type]
            && currentTypeTable[type][option]
            && currentTypeTable[type][option].warning == true
        ){
            return 'warning'
        }
        else if (
            build
            && build[type]
            && build[type].item.contents
            && currentTypeTable
            && currentTypeTable[type]
            && currentTypeTable[type][option]
            && currentTypeTable[type][option].compatible == true
        ){
            return true
        }
        else return
    },
    // Returns the stored compatibility message (used for warning tooltips) for a
    // given current item vs. withType/option. Mirrors checkCompatTable's lookup.
    getCompatMessage(type, option, build, item, compatTable){
        var currentItemType = item && normalizeCompatType(item.type)
        var currentTypeTable = getCompatTypeTable(compatTable, currentItemType)
        if(currentItemType
            && currentTypeTable
            && currentTypeTable[type]
            && currentTypeTable[type][option]){
            return currentTypeTable[type][option].message || ''
        }
        return ''
    },
    getItemValue({item, field}){
        if(item && item !== null){
            // console.log('getting item value: ', field, ' from ', item)
            var type = ''
            var length = 0
            var capacity = 0
            var ram_type
            if(item && typeof(item) == 'object' && item.length >0){
                type = item[0].type
                length = item.length
            }
            else {
                type = item.type
            }
            // console.log('item type recognized: ', type)

            if(type == 'motherboard'){
                if(field == 'ram_type'){
                    ram_type = item.compat.ram
                    // console.log('returning ram type ', item.compat.ram)
                    return ram_type
                }
            }
            if(type == 'ram'){
                if(field == 'capacity'){
                    capacity = 0
                    if(length >0){
                        item.map((itm) => capacity += parseInt(itm.compat.capacity))
                    }
                    return capacity
                }
                if(field == 'ram_type'){
                    ram_type = item[0].compat.ram_type
                    // console.log('returning ram type ', item[0].compat.ram_type)
                    return ram_type
                }
                if(field == 'slots'){
                    var slots = 0
                    if(length >0){
                        item.map((itm) => slots += parseInt(itm.compat.number_of_items))
                    }
                    return slots
                }
            }
            if(type == 'storage'){
                if(field == 'capacity'){
                    capacity = 0
                    if(length >0){
                        item.map((itm) => capacity += parseInt(itm.specs.Capacity))
                    }
                    return capacity
                }
            }
        }
    },  
    parsePrice(value){
        if(value === null || value === undefined || value === ''){
            return null
        }
        if(typeof(value) == 'number'){
            if(isNaN(value) || !isFinite(value)){
                return null
            }
            return value
        }
        var normalized = String(value).replace(/[^0-9.-]+/g, '')
        if(normalized === '' || normalized === '-' || normalized === '.' || normalized === '-.'){
            return null
        }
        var numericPrice = parseFloat(normalized)
        if(isNaN(numericPrice) || !isFinite(numericPrice)){
            return null
        }
        return numericPrice
    },
    // Tolerance on the typical-price band. Every surface that shows an estimated
    // price (list, slider, checklist total, mobile dock, buy panel) derives from
    // this one number, and so does the copy that quotes it -- change it here only.
    // Kept in step with the Nuxt catalog's TYPICAL_PRICE_VARIANCE.
    TYPICAL_PRICE_VARIANCE: 0.05,
    typicalPriceVarianceLabel(){
        return '±' + Math.round(this.TYPICAL_PRICE_VARIANCE * 100) + '%'
    },
    priceBand(value, variance){
        var numericPrice = this.parsePrice(value)
        if(numericPrice === null || numericPrice <= 0){
            return null
        }
        var percentage = this.parsePrice(variance)
        if(percentage === null || percentage < 0){
            percentage = this.TYPICAL_PRICE_VARIANCE
        }
        return {
            low: numericPrice * (1 - percentage),
            high: numericPrice * (1 + percentage),
        }
    },
    formatUsd(value, includeCents){
        var numericPrice = this.parsePrice(value)
        if(numericPrice === null || numericPrice <= 0){
            return ''
        }
        var digits = includeCents === false ? 0 : 2
        return '$' + numericPrice.toLocaleString('en-US', {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        })
    },
    formatTypicalPriceBand(value){
        var band = this.priceBand(value, this.TYPICAL_PRICE_VARIANCE)
        if(!band){
            return ''
        }
        // Floor both bounds at $1: formatUsd renders anything <= 0 as an empty
        // string, which turned a sub-dollar part into a broken "-$1".
        return this.formatUsd(Math.max(1, Math.round(band.low)), false)
            + '\u2013'
            + this.formatUsd(Math.max(1, Math.round(band.high)), false)
    },
    priceRecordedAt(item){
        if(!item || !item.price){
            return ''
        }
        return item.price.recorded_at
            || item.price.recordedAt
            || item.price.updated_at
            || item.price.updatedAt
            || ''
    },
    formatPriceRecordedAt(item){
        var raw = this.priceRecordedAt(item)
        if(!raw){
            return ''
        }
        var parsed = new Date(raw)
        if(isNaN(parsed.getTime())){
            return ''
        }
        return parsed.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        })
    },
    cents(num){
        var numericPrice = this.parsePrice(num)
        if(numericPrice === null){
            return '00'
        }
        var numbr = numericPrice.toFixed(2)
        var remainder = numbr%1
        var cents = (remainder*100).toFixed(0)
        if(cents == 0){
            return '00'
        }
        if(cents < 10){
          return '0'+cents
        }
        return cents
    },
    getItemValueMenu({item, field}){
        console.log('getting item value: ', field, ' from ', item)
        var type = ''
        var length = 0
        var capacity = 0
        if(item && typeof(item) == 'object' && item.length >0){
            type = item[0].type
            length = item.length
        }
        else {
            type = item.type
        }
        if(type == 'ram'){
            if(field == 'capacity'){
                capacity = 0
                if(length >0){
                    item.map((itm) => capacity += parseInt(itm.compat.capacity))
                }
                return capacity
            }
        }
        if(type == 'storage'){
            if(field == 'capacity'){
                capacity = 0
                if(length >0){
                    item.map((itm) => capacity += parseInt(itm.specs.Capacity))
                }
                return capacity
            }
        }
        if(type == 'graphics' || type == 'gpu'){
            if(field == 'model'){
                var model = item.model || ''
                if(length >0){
                    model = item[0].model
                }
                console.log('got model: ', model)
                return model
            }
        }
    },
}
